

export const environment = {
  production: false,
  appApi: 'https://api.focuzphysio.net',
  backend: { spring: false, php: true, node: false }, //first true will be applied make spring false and then make node true to use node app
  auth: {
    login: 'https://api.focuzphysio.net/api/auth/login',  //Node js '/signin/' // Spring Boot build in '/oauth/token/'
    // logout: 'https://api.Focusphysio.in//auth/logout',
    register: 'https://api.focuzphysio.net/auth/register',
    clientId: '',  //Required for Spring boot, left empty for node js php
    clientSecret: ''  //Required for Spring boot, left empty for node js php
  }
};

